import { render, staticRenderFns } from "./CardVentas.vue?vue&type=template&id=0e8e2062&scoped=true"
import script from "./CardVentas.vue?vue&type=script&lang=js"
export * from "./CardVentas.vue?vue&type=script&lang=js"
import style0 from "./CardVentas.vue?vue&type=style&index=0&id=0e8e2062&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8e2062",
  null
  
)

export default component.exports